import {CommentJSONValue, parse as commentJsonParse, Reviver, stringify as commentJsonStringify} from "comment-json";

export function stringify(value: any, replacer?: ((key: string, value: any) => any) | Array<number | string> | null, space?: string | number): string {
  return commentJsonStringify(value, replacer, space);
}

export function parse(json: string, reviver?: Reviver, removes_comments?: boolean): CommentJSONValue {
  return commentJsonParse(json, reviver, removes_comments);
}

export function cloneDeepJSON<T>(value: T): T {
  return parse(stringify(value, null, 2)) as T;
}
